// Entrada al panel: correo y contraseña y, si la cuenta tiene 2FA, el código de la app (o uno de recuperación).
import { useState, type FormEvent } from 'react';
import { api } from '../api.ts';
import { t } from '../i18n/index.ts';
import { navigate } from '../router.ts';
import { errorText, useApp } from '../store.ts';
import { LogoMark } from '../ui/Logo.tsx';

export function Login() {
  const setMe = useApp((s) => s.setMe);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [ticket, setTicket] = useState<string | null>(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (ticket) {
        const r = await api.mfa(ticket, code);
        setMe(r.user);
        navigate('/', true);
      } else {
        const r = await api.login(email, password);
        if (r.mfa && r.ticket) setTicket(r.ticket);
        else if (r.user) {
          setMe(r.user);
          navigate('/', true);
        }
      }
    } catch (err) {
      setError(errorText(err));
      if (ticket) setCode('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <span className="login-logo">
          <LogoMark height={40} />
        </span>
        <h1>{ticket ? t('login.mfaTitle') : t('login.title')}</h1>
        {ticket ? (
          <>
            <p className="hint">{t('login.mfaHint')}</p>
            <input
              className="input"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder={t('login.code')}
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              required
            />
          </>
        ) : (
          <>
            <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('login.email')} autoComplete="username" autoFocus required />
            <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t('login.password')} autoComplete="current-password" required />
          </>
        )}
        {error ? <p className="error">{error}</p> : null}
        <button className="btn primary" type="submit" disabled={busy}>
          {ticket ? t('login.verify') : t('login.submit')}
        </button>
        {ticket ? (
          <button
            className="btn ghost"
            type="button"
            onClick={() => {
              setTicket(null);
              setCode('');
              setError(null);
            }}
          >
            {t('common.back')}
          </button>
        ) : null}
      </form>
    </div>
  );
}
